export enum SyncMode {
  Manual = 'manualTab',
  Auto = 'autoTab',
  Email = 'emailTab'
}
